import { useState } from "react";
import { Link } from "react-router";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ChangeEmailForm } from "./change-email-form";
import { ReauthenticateUser } from "./reauthenticate-user";
import { useChangeEmail } from "../../hooks/use-change-email";
import { useTimeout } from "../../hooks/use-timeout";

const schema = yup
    .object({
        newEmail: yup
            .string()
            .required("Please enter your new email address")
            .email("Enter an email like name@example.com"),
    })
    .required();

export const ChangeEmail = () => {
    const [reauthenticated, setReauthenticated] = useState(false);

    // If user idle for 5 mins then show reauthenticate form again
    useTimeout(reauthenticated, setReauthenticated);

    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const mutation = useChangeEmail(setReauthenticated);

    const onSubmit = (data) => {
        mutation.mutate(data);
    };

    if (reauthenticated) {
        return (
            <>
                <div className="grid grid-cols-12 items-start gap-y-6">
                    <Card size="lg" className="grid grid-cols-12 gap-y-8">
                        <div className="col-span-full">
                            <h2 className="mb-3 text-xl font-semibold">
                                Enter your new email address
                            </h2>
                        </div>
                        <ChangeEmailForm
                            methods={methods}
                            onSubmit={onSubmit}
                            isPending={mutation.isPending}
                        />
                        <div className="col-span-full">
                            <p className="text-sm/6">
                                A verification link will be sent to your new
                                email address
                            </p>
                        </div>
                        <div className="col-span-full">
                            <Button variant="secondary" size="sm" asChild>
                                <Link to=".." relative="path">
                                    Go back
                                </Link>
                            </Button>
                        </div>
                    </Card>
                </div>
            </>
        );
    }

    return (
        <ReauthenticateUser
            onReauthenticated={() => setReauthenticated(true)}
        />
    );
};
